<div id="root">
  <div class="fixed-background">
    <main>
      <div class="container">
        <div class="row h-100">
          <div class="col-10 col-md-8 mx-auto my-auto" style="text-align: center;">
            <div class="card auth-card">
              <div class="form-side">
                <a routerLink="/">
                  <span class="logo-single"></span>
                </a>
                <h6 class="mb-4">{{ "pages.no-access-title" | translate }}</h6>
                <p class="mb-5 text-muted">
                  {{ "pages.no-access-message" | translate }}
                </p>
                <button type="button" class="btn btn-primary btn-lg btn-shadow" (click)="onSignOut()">
                  {{ "menu.sign-out" | translate | uppercase }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</div>
